import React, {useEffect, useState} from 'react';
import "./singleUploader.css"
import Resizer from "react-image-file-resizer";
import Api from "../../utils/api";
import {toast} from "react-toastify";

const MoreImage = (props) => {
    const {name} = props
    const {disable} = props
    const {onChange} = props
    const {data} = props
    const {placeholder} = props

    const [src, setSrc] = useState(null )

    useEffect(() => {
        if(data) {
            setSrc("http://api.digiattar.com/storage/overly/" + data.data?.[0]?.file?.file)
        }
    } ,[data])

    const resizeFile = (file) => {
        return new Promise((resolve) => {
            Resizer.imageFileResizer(
                file,
                1000,
                1000,
                "png",
                100,
                0,
                (uri) => {
                    resolve(uri);
                },
                "file"
            );
        })

    }

    const upload = async (e) => {
        const file = e.target.files[0];
        let image = await resizeFile(file)

        const formData = new FormData();

        setSrc(URL.createObjectURL(file))

        formData.append('file', image);
        formData.append('title', "first_overly");
        formData.append('form', "overly_store");
        formData.append('opacity', 50);

        onChange(formData);


    }

    return (
        <div className={`singleUploader ${disable && "disable"} gallery`}>
            <img  src={src}/>
            <input
                name={name}
                id={"singleUploader"}
                type={"file"}
                onChange={(e) => upload(e)}
            />
            <label htmlFor={"singleUploader"}>
                {
                    <div className={"uploader_icon"}>
                        بارگزاری تصویر
                        {placeholder}
                    </div>
                }
            </label>
        </div>
    );
};

export default MoreImage;